import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { isAuthenticated } from "../shared/utils";
import { Navigate, Outlet } from "react-router-dom";
const ProtectedRouter = ({ layout: Layout, }) => {
    return isAuthenticated() ? (_jsx(_Fragment, { children: _jsx(Layout, { children: _jsx(Outlet, {}) }) })) : (_jsx(_Fragment, { children: _jsx(Navigate, { to: "/no-auth" }) }));
};
export default ProtectedRouter;
